import { render, staticRenderFns } from "./UserPurchaseList.vue?vue&type=template&id=55cf8834&scoped=true"
import script from "./UserPurchaseList.vue?vue&type=script&lang=js"
export * from "./UserPurchaseList.vue?vue&type=script&lang=js"
import style0 from "./UserPurchaseList.vue?vue&type=style&index=0&id=55cf8834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf8834",
  null
  
)

export default component.exports